module.exports = __webpack_public_path__ + "img/emoji-tivoli-240x240.b4d20931.png";